export default __webpack_public_path__ + "static/media/benefit1.fe345118.svg";